import React, { useState } from 'react';
import { faqTabs, type FaqItem } from '../data/faqData';

const WHATSAPP_NUMBER = '4915228301212';
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  'Merhaba, sıkça sorulan sorular sayfasından ulaşıyorum. Bir sorum var:',
)}`;

const FaqAccordionItem: React.FC<{ faq: FaqItem; isOpen: boolean; onToggle: () => void }> = ({
  faq,
  isOpen,
  onToggle,
}) => {
  return (
    <div className={`sss-accordion-item${isOpen ? ' sss-accordion-open' : ''}`}>
      <button className="sss-accordion-header" onClick={onToggle} aria-expanded={isOpen}>
        <span className="sss-accordion-question">{faq.question}</span>
        <span className="sss-accordion-icon" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>
      {isOpen && (
        <div className="sss-accordion-body">
          <p className="sss-accordion-answer">{faq.answer}</p>
        </div>
      )}
    </div>
  );
};

const SSSPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>(faqTabs[0].key);
  const [openKey, setOpenKey] = useState<string | null>(`${faqTabs[0].key}-0`);

  const currentTab = faqTabs.find((t) => t.key === activeTab) || faqTabs[0];

  return (
    <div className="sss-page">
      <div className="sss-container">
        <div className="sss-header">
          <h1 className="sss-title">Sıkça Sorulan Sorular</h1>
        </div>

        <div className="sss-tabs">
          {faqTabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              className={`sss-tab${activeTab === tab.key ? ' active' : ''}`}
              aria-pressed={activeTab === tab.key}
              onClick={() => {
                setActiveTab(tab.key);
                setOpenKey(`${tab.key}-0`);
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="sss-accordion">
          {currentTab.items.map((faq, index) => {
            const itemKey = `${currentTab.key}-${index}`;
            return (
              <FaqAccordionItem
                key={itemKey}
                faq={faq}
                isOpen={openKey === itemKey}
                onToggle={() => setOpenKey(openKey === itemKey ? null : itemKey)}
              />
            );
          })}
        </div>

        <div className="sss-cta">
          <h2 className="sss-cta-title">Başka sorunuz mu var?</h2>
          <p className="sss-cta-text">
            Yanıtını bulamadığınız sorular için WhatsApp üzerinden bize yazabilirsiniz.
          </p>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="sss-cta-button"
          >
            WhatsApp'tan Bize Yazın
          </a>
        </div>
      </div>
    </div>
  );
};

export default SSSPage;
